import { render, staticRenderFns } from "./RevenueGraphDistributionComponent.vue?vue&type=template&id=70254934&scoped=true"
import script from "./RevenueGraphDistributionComponent.vue?vue&type=script&lang=js"
export * from "./RevenueGraphDistributionComponent.vue?vue&type=script&lang=js"
import style0 from "./RevenueGraphDistributionComponent.vue?vue&type=style&index=0&id=70254934&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70254934",
  null
  
)

export default component.exports